module.exports = __webpack_public_path__ + "RedStrategy.1a1efe1.png";